import PlatformActions from './PlatformActions'

export default class MGEGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'MG-EGAME-011',
      platform: 'MG',
    }

    this.gameName = 'Plinko Pop'
    this.roundIdPrefix = 'AIBQACYATFA3O2IA'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${this.roundIdPrefix}${roundId}`, // AIBQAAQATFA3O2IAAAAAAAYAAAAA
      roundId: `${this.roundIdPrefix}${roundId}`, // AIBQAAQATFA3O2IAAAAAAAYAAAAA
      betType: null,
      currency,
      betTime, // 2026-08-31T14:27:06.713+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {},
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      settleTxnId,
      roundId,
      betTime,
      updateTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: winAmount > 0 && !isEndRound ? `${this.roundIdPrefix}${settleTxnId}` : `${this.roundIdPrefix}${roundId}`, // win + !isEndRound: AIBQAAQATFA3O2IAAAAABIHLAXIQUAAAAAAA, win/lose + isEndRound: AIBQAAQATFA3O2IAAAAAAAYAAAAA
      refPlatformTxId: `${this.roundIdPrefix}${roundId}`, // AIBQAAQATFA3O2IAAAAAAAYAAAAA
      settleType: 'refPlatformTxId',
      updateTime, // 2026-08-31T14:19:29.978+08:00
      roundId: `${this.roundIdPrefix}${roundId}`, // AIBQAAQATFA3O2IAAAAAAAYAAAAA
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        ...(isEndRound && { isEndRound }),
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${this.roundIdPrefix}${roundId}`,
      roundId: `${this.roundIdPrefix}${roundId}`,
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
